const FALLBACK_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'local';

let runtimeEnvironment: Environment | null = null;
let runtimeEnvironmentPromise: Promise<Environment> | null = null;

const parseEnvironment = (value: unknown): Environment | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const environment = value.trim() as Environment;
  return environment.length ? environment : null;
};

const fetchRuntimeEnvironment = async (): Promise<Environment> => {
  if (typeof window === 'undefined') {
    return process.env.ENVIRONMENT ?? FALLBACK_ENVIRONMENT;
  }

  try {
    const response = await fetch('/api/env', {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      return FALLBACK_ENVIRONMENT;
    }

    const data = (await response.json()) as { environment?: unknown };
    return parseEnvironment(data.environment) ?? FALLBACK_ENVIRONMENT;
  } catch {
    return FALLBACK_ENVIRONMENT;
  }
};

export const getInitialClientEnvironment = (): Environment =>
  parseEnvironment(runtimeEnvironment) ?? FALLBACK_ENVIRONMENT;

export const getRuntimeClientEnvironment = async (): Promise<Environment> => {
  if (runtimeEnvironment) {
    return runtimeEnvironment;
  }

  if (!runtimeEnvironmentPromise) {
    runtimeEnvironmentPromise = fetchRuntimeEnvironment()
      .then((environment) => {
        runtimeEnvironment = environment;
        return environment;
      })
      .finally(() => {
        runtimeEnvironmentPromise = null;
      });
  }

  return runtimeEnvironmentPromise;
};
